import styled from "@emotion/styled";
import { MDSText } from "@/mds/components/text";
import { MDSMenuItemVariant, MDSMenuItemIconVariant } from "./menu-item.types";

const VARIANT_HEIGHT_MAP: Record<MDSMenuItemVariant, string> = {
  [MDSMenuItemVariant.OneLine]: "32px",
  [MDSMenuItemVariant.TwoLine]: "50px",
};

export const StyledWrapper = styled.div<{ $variant: MDSMenuItemVariant; $isHovered: boolean }>(
  ({ theme, $variant, $isHovered }) => `
  padding: ${theme.spacing[2]} ${theme.spacing[5]};
  border: none;
  border-radius: 0;
  margin: 0;
  display: flex;
  flex-shrink: 0;
  align-items: center;
  gap: ${theme.spacing[2]};
  cursor: pointer;
  background-color: ${$isHovered ? theme.colors.background.menu.hover : theme.colors.background.menu.default};
  height: ${VARIANT_HEIGHT_MAP[$variant]};

  &[data-focused], [data-focused] & {
    background-color: ${theme.colors.background.menu.hover};
  }

  &[data-selected], [data-selected] & {
    background-color: ${theme.colors.background.menu.selected};
  }

  &[data-disabled], [data-disabled] & {
    opacity: 0.6;
    cursor: not-allowed;
  }

  &:hover:not([data-disabled]), :hover:not([data-disabled]) & {
    background-color: ${theme.colors.background.menu.hover};
  }
`
);

export const StyledIconWrapper = styled.div<{
  $iconVariant: MDSMenuItemIconVariant;
  $hasSubtitle: boolean;
}>`
  display: flex;
  align-items: ${({ $iconVariant, $hasSubtitle }) =>
    $iconVariant === MDSMenuItemIconVariant.Avatar || !$hasSubtitle ? "center" : "flex-start"};
  justify-content: center;
  align-self: stretch;
  flex-shrink: 0;
  padding-right: ${({ theme, $iconVariant }) =>
    $iconVariant === MDSMenuItemIconVariant.Avatar ? theme.spacing[1] : 0};
`;

export const StyledContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0;
  flex: 1;
  min-width: 0;
  max-width: 100%;
`;

export const StyledTitleRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing["2"]};
  max-width: 100%;
`;

export const StyledTitle = styled(MDSText)`
  max-width: 100%;
  font-size: ${({ theme }) => theme.fontSizes["text-s"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.primary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledExtraText = styled(MDSText)`
  font-size: ${({ theme }) => theme.fontSizes["text-s"]};
  line-height: ${({ theme }) => theme.lineHeights["text-s"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
`;

export const StyledSubtitle = styled.div`
  margin-top: ${({ theme }) => theme.spacing[0.5]};
  font-size: ${({ theme }) => theme.fontSizes["text-xs"]};
  line-height: ${({ theme }) => theme.lineHeights["text-xs"]};
  font-weight: ${({ theme }) => theme.fontWeights.regular};
  color: ${({ theme }) => theme.colors.text.secondary};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const StyledRightAddon = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  align-self: stretch;
`;
